import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-rijpma',
  templateUrl: './home-rijpma.component.html',
  styleUrls: ['./home-rijpma.component.scss']
})
export class HomeRijpmaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
